import { Component, OnInit, OnDestroy, Input, EventEmitter, Output, ViewChild, ElementRef, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-gps-input',
    templateUrl: './gps-input.component.html',
    styleUrls: ['./gps-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => GPSInputComponent), // replace name as appropriate
            multi: true
        }
    ],
    standalone: false
})
export class GPSInputComponent implements OnInit, OnDestroy, ControlValueAccessor {
  ngUnsubscribe = new Subject<boolean>();

  _value: string;
  @Input() get value() {
    return this._value ?? '';
  }
  set value(val) {
    this._value = val;
  }
  @Output() valueChange = new EventEmitter<string>();

  @Input()
  isDisabled = false;

  @Input()
  description: string;

  isEditing: boolean;
  @ViewChild('editInput') editInput: ElementRef;

  constructor() { }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
  }

  onKeyUp() {

    let valueAsInt: number;
    const isInt: boolean = !isNaN(Number(this._value + '1'));
    valueAsInt = Number(this._value);
    if (this._value && isInt) {
      const decimalPart = this._value.split('.')[1];
      if (decimalPart && decimalPart.length > 15) {
        this._value = this.getTruncatedFixed(valueAsInt, 15);
      }
      this.valueChange.emit(this.value);
    } else {
      this.valueChange.emit(null);
    }
  }

  getTruncatedFixed(value: number, decimals: number) {
    if (value >= 0) {
      return (Math.floor(value * Math.pow(10, decimals)) / Math.pow(10, decimals)).toFixed(decimals);
    } else {
      return (Math.ceil(value * Math.pow(10, decimals)) / Math.pow(10, decimals)).toFixed(decimals);
    }
  }

  onFocusIn() {
    this.isEditing = true;
    setTimeout(() => {
      this.editInput.nativeElement.focus();
    });
  }

  onFocusOut() {
    this.isEditing = false;
    this.valueChange.emit(this.value);
    this.onTouch(this.value);
    this.onChange(this.value);
  }

  onChange: any = () => { }

  onTouch: any = () => { }

  writeValue(value: any) {
    this.value = value;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }
}
